module.exports = __webpack_public_path__ + "img/2.55690c8d.png";